import React from 'react';
import PropTypes from 'prop-types';
import BotInputControl from './ctrl_input';
import RadioButton from '../../../../../../controls/radiobutton';
import Button from '../../../../../../controls/button';

// import Logger from '../../../../../../../common/logger';

class BotRadiobuttonInputsControl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCheckbox: '',
            selectedCheckboxText: '',
            selectedInputValue: '',
            isInputValid: false
        };
    }

    isValid(id, text, value, isValid) {
        this.setState({
            selectedCheckbox: id,
            selectedCheckboxText: text,
            selectedInputValue: value,
            isInputValid: isValid
        });
    }

    onSubmit() {
        this.props.onSubmit({
            buttonId: this.state.selectedCheckbox,
            buttonText: this.state.selectedCheckboxText,
            inputValue: this.state.selectedInputValue
        });
    }

    onClick(id, text) {
        if (this.props.enabled) {
            this.setState({
                selectedCheckbox: id,
                selectedCheckboxText: text,
                isInputValid: id != this.state.selectedCheckbox ? false : this.state.isInputValid
            });
        }
    }

    render() {
        const radiobuttons = this.props.inputs
            ? this.props.inputs.map((input, i) => (
                <div key={i} className="botRadiobutton">
                    <RadioButton
                        id={'radio' + input.id}
                        name="inputs"
                        disabled={this.props.enabled ? false : true}
                        value={input.text}
                        checked={this.state.selectedCheckbox === input.id ? true : false}
                        onChange={() => this.onClick(input.id, input.text)}
                    />
                    <br />
                    <BotInputControl
                        id={input.id}
                        enabled={this.props.enabled}
                        validationType={input.type}
                        onChange={(value, isValid) =>
                            this.isValid(input.id, input.text, value, isValid)
                        }
                        onClick={() => this.onClick(input.id, input.text)}
                    />
                </div>
            ))
            : null;

        return (
            <div className="botRadiobuttonInputs">
                {
                    <div>
                        {radiobuttons}
                        <Button
                            className="white"
                            disabled={!(this.props.enabled && this.state.isInputValid)}
                            text="Wybierz"
                            onClick={() => this.onSubmit()}
                        />
                    </div>
                }
            </div>
        );
    }
}

BotRadiobuttonInputsControl.defaultProps = {
    inputs: [],
    enabled: false
};

BotRadiobuttonInputsControl.propTypes = {
    inputs: PropTypes.array,
    enabled: PropTypes.bool
};

export default BotRadiobuttonInputsControl;
